function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties(source, excluded) {
  if (source == null) return {};
  var target = _object_without_properties_loose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
import { Link } from "@custom/schema";
import clsx from "clsx";
import React from "react";
import { ArrowRight } from "react-feather";
export var LinkItem = function LinkItem(_param) {
  var text = _param.text,
    href = _param.href,
    showIcon = _param.showIcon,
    children = _param.children,
    _param_inline = _param.inline,
    inline = _param_inline === void 0 ? false : _param_inline,
    _param_hasResponsiveTextSize = _param.hasResponsiveTextSize,
    hasResponsiveTextSize = _param_hasResponsiveTextSize === void 0 ? false : _param_hasResponsiveTextSize,
    textClassName = _param.textClassName,
    _param_groupHover = _param.groupHover,
    groupHover = _param_groupHover === void 0 ? false : _param_groupHover,
    _param_isDecorative = _param.isDecorative,
    isDecorative = _param_isDecorative === void 0 ? false : _param_isDecorative,
    props = _object_without_properties(_param, ["text", "href", "showIcon", "children", "inline", "hasResponsiveTextSize", "textClassName", "groupHover", "isDecorative"]);
  var linkText = /*#__PURE__*/React.createElement("span", {
    className: clsx("underline decoration-primary-black group-focus-visible:no-underline transition-all duration-300 ease-in hover:shadow-[inset_0_-30px_0_0_color-mix(in_srgb,_var(--color-theme-light)_50%,_transparent)] rounded-t-lg pt-1 break-words", {
      "group-hover:shadow-[inset_0_-30px_0_0_color-mix(in_srgb,_var(--color-theme-light)_50%,_transparent)]": groupHover
    })
  }, text, children);
  var linkClassName = clsx("underline decoration-double decoration-theme-light/50 focus-visible:no-underline group focus-visible:!outline-1 focus-visible:rounded-sm");
  return /*#__PURE__*/React.createElement("div", {
    className: clsx("text-primary-black", textClassName, {
      inline: inline,
      "text-16 md:text-18 leading-160%": hasResponsiveTextSize,
      "text-18 leading-160%": !hasResponsiveTextSize
    })
  }, showIcon && /*#__PURE__*/React.createElement("span", {
    className: "me-1 inline-block h-4.5 pt-1"
  }, /*#__PURE__*/React.createElement(ArrowRight, {
    "aria-hidden": "true",
    className: "h-4 w-4"
  })), isDecorative ? /*#__PURE__*/React.createElement("span", {
    className: linkClassName
  }, linkText) : /*#__PURE__*/React.createElement(Link, _object_spread_props(_object_spread({
    href: href
  }, props), {
    className: linkClassName
  }), linkText));
};